/**
 * Define whole set of messages for communication between browser app and its engine part.
 */

'use strict';

var messageTypes = {
    toEngine: [
        'reload',
        'stopLoad',
        'navigateForward',
        'navigateBackward',
        'hideWebWindow',
        'openVirtualKeyboard',
        'search',
        'setFullScreen',
        'userTextInput',
        'userSettings',
        'showWebWindow',
        'intentUrl'
    ],
    toApp: [
        'ready',
        'openTaskManager',
        'openMenu',
        'home',
        'back',
        'search',
        'openSettings',
        'notification',
        'favoritesState',
        'setFavicon',
        'unsetFavicon',
        'setLoadProgress',
        'changeUrl',
        'reload',
        'mediaAvailable'
    ]
};

Object.keys(messageTypes).forEach(function ( messageReceiver ) {
    messageTypes[messageReceiver] = messageTypes[messageReceiver].reduce(function ( messages, message ) {
        messages[message] = message;

        return messages;
    }, {});
});


module.exports = messageTypes;
